import { initScrollAnimations } from './modules/scroll-animations.js';
import { initNav } from './modules/nav.js';
import { initTestimonialsSlider } from './modules/testimonials.js';
import { initContactForm } from './modules/contact-form.js';
import { initPortfolioModal } from './modules/portfolio-modal.js';
import { initMotionEffects } from './modules/motion-effects.js';
import { initStatsCounters } from './modules/stats-counter.js';

initNav();
initPortfolioModal();
initScrollAnimations();
initMotionEffects();
initStatsCounters();
initTestimonialsSlider();
initContactForm();

const yearEl = document.querySelector('[data-year]');
if (yearEl) yearEl.textContent = String(new Date().getFullYear());
